import axios from 'axios'
import { env } from './../config'

export async function getNews() {
    return axios.get(`${env.BASE_URL}/news`)
}